import { DOCUMENT } from '@angular/common';
import { filter, map } from 'rxjs/operators';
import { Platform } from '@angular/cdk/platform';
import { Injectable, inject } from '@angular/core';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { LocalRepository } from '@shared/helper/local-repository';
import { AppStateService } from '../../../app/state/app-state.service';
import { SwUpdate, VersionReadyEvent } from '@angular/service-worker';
import { PromptBottomsheetComponent } from '@shared/components/bottom-sheets/prompt-bottomsheet/prompt-bottomsheet.component';
@Injectable({
  providedIn: 'root'
})
export class PwaService {
  private platform = inject(Platform);
  private readonly updates = inject(SwUpdate);
  private _bottomSheet = inject(MatBottomSheet);
  private doc = inject<Document>(DOCUMENT);
  private _localRepository = inject(LocalRepository);
  private appStateService = inject(AppStateService);

  nowMilliseconds = 0;
  private promptEvent!: object;
  objectMilliseconds = 0;
  showInstalPrompt = false;

  constructor() {
    const updates = this.updates;
    const doc = this.doc;

    updates.unrecoverable.subscribe(() => {
      if (this._localRepository.IsInBrowser) {
        doc.location.reload()
      }
    });

  }

  public StartPWA() {

    if (this.updates.isEnabled) {
      this.updates.versionUpdates.pipe(
        filter((evt): evt is VersionReadyEvent => evt.type === 'VERSION_READY'),
        map(evt => ({
          type: 'UPDATE_AVAILABLE',
          current: evt.currentVersion,
          available: evt.latestVersion,
        }))
      )
        .subscribe(res => {
          if (res.type === 'UPDATE_AVAILABLE') {
            this.appStateService.updateAvailible$ = true;
          }
        })

      this.updates.checkForUpdate();
    }


    this.nowMilliseconds = new Date().getTime();
    const savedTime = +this._localRepository.getLocalItem('PWA')!;
    const savedDate = new Date(savedTime).toString();
    const objectDate = new Date(Date.parse(savedDate));
    this.objectMilliseconds = objectDate.getTime();
    if (this._localRepository.IsInBrowser) {
      const fff = this.nowMilliseconds - this.objectMilliseconds;
      const objectMinutes = Math.floor((fff / 1000 / 60));
      const objectHours = Math.floor(objectMinutes / 60);
      this.showInstalPrompt = objectHours > 0 ? true : false;

      if (this.showInstalPrompt) {
        if (this.platform.ANDROID) {
          // ? Just in Https server Work Correctly
          this.doc.defaultView!
            .addEventListener('beforeinstallprompt', (event: Event) => {
              event.preventDefault();
              this.promptEvent = event;
              const OpenBottomSheet = this._bottomSheet.open(PromptBottomsheetComponent,
                {
                  data:
                  {
                    mobileType: 1,
                    promptEvent: this.promptEvent
                  },
                  panelClass: 'basic-bottomsheet'
                }
              );

              OpenBottomSheet.afterDismissed().subscribe(() => {
                if (this._localRepository.IsInBrowser) {
                  this._localRepository.setLocalItem('PWA', Date.now().toString())
                }
              })
            });
        }
        if (this.platform.IOS) {
          const isInStandaloneMode = ('standalone' in this.doc.defaultView!.navigator) && (this.doc.defaultView!.navigator['standalone']);
          if (!isInStandaloneMode) {
            const OpenBottomSheet = this._bottomSheet.open(PromptBottomsheetComponent,
              {
                data:
                {
                  mobileType: 2,
                  promptEvent: this.promptEvent
                },
                panelClass: 'basic-bottomsheet'
              }
            );

            OpenBottomSheet.afterDismissed().subscribe(() => {
              if (this._localRepository.IsInBrowser) {
                this._localRepository.setLocalItem('PWA', Date.now().toString())
              }
            })
          }
        }
      }
    }

  }
}
